import { useEffect, useState } from "react";
import dynamic from "next/dynamic";

import getPromotedStrains from "api/requests/getPromotedStrains";
import { Action, Category } from "constants/events";
import { PromotedStrain } from "custom-types/Directus";
import { useEventTracker } from "hooks/useEventTracker";
import useFilters from "hooks/useFilters";

import Placeholder, { Rect } from "components/Placeholder";

const PromotedStrainCarousel = dynamic(
  () => import("components/StrainCarousel"),
);

const ShopPromotedStrainsCarousel: React.FC = () => {
  const { addFilter } = useFilters();
  const { publishEvent } = useEventTracker();

  const [strains, setStrains] = useState<PromotedStrain[]>();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getPromotedStrains()
      .then((strains) => setStrains(strains))
      .finally(() => setLoading(false));
  }, []);

  return loading || strains === undefined ? (
    <div className="overflow-hidden mt-14">
      <div className="flex">
        {new Array(5).fill(null).map((_, i) => (
          <div key={i} className="flex-shrink-0 w-[188px] mr-lg py-xl">
            <Placeholder
              width="112"
              height="112"
              className="-rotate-45 mx-auto"
            >
              <Rect width="112" height="112" />
            </Placeholder>
            <Placeholder width="50%" height="14" className="mt-9 mx-auto">
              <Rect width="100%" height="100%" />
            </Placeholder>
          </div>
        ))}
      </div>
    </div>
  ) : (
    <PromotedStrainCarousel
      promotedStrains={strains}
      onClick={(strain) => {
        addFilter({
          strain_name: strain.strain_name,
        });

        publishEvent({
          action: Action.click,
          category: Category.dealsOnTopStrains,
          label: `strain hub quick access - ${strain.strain_name}`,
        });
      }}
    />
  );
};

export default ShopPromotedStrainsCarousel;
